module.exports = __webpack_public_path__ + "static/media/banner-photo360.cd0265bd.jpg";